export const SPECIES_CATEGORIES = [
  'Fish', 'Mammal', 'Bird', 'Reptile', 'Amphibian',
  'Tree', 'Plant', 'Berry', 'Fungus', 'Medicine',
  'Aquatic Resource', 'General Resource', 'Environmental Observation',
];
